import { getDefaultHeader } from '../../services/serviceAPIHelper';
import { getUserInformation } from '../Login/loginService';

export const getCurrentUser = function () {
    let user = getUserInformation();
    const url = process.env.REACT_APP_API_URL + 'users/' + user.user_name+'/me';
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const saveCurrentUser = function (userDTO) {
    let user = getUserInformation();
    const url = process.env.REACT_APP_API_URL + 'users/' + user.user_name;
    return fetch(url, {
        method: 'PUT',
        headers: getDefaultHeader(true),
        body:JSON.stringify(userDTO)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};
export const getUsers = function () {
    const url = process.env.REACT_APP_API_URL + 'users';
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const deleteUser = function (user) {
    const url = process.env.REACT_APP_API_URL + 'users/' + user.user_name;
    return fetch(url, {
        method: 'DELETE',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const addUser = function (user) {
    const url = process.env.REACT_APP_API_URL + 'users/';
    return fetch(url, {
        method: 'POST',
        headers: getDefaultHeader(true),
        body:JSON.stringify(user)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const updateUser = function (userDTO) {
    userDTO.userDetail.jobTitle = userDTO.jobTitle;
    userDTO.userDetail.language = userDTO.language;
    const url = process.env.REACT_APP_API_URL + 'users/' + userDTO.userName;
    return fetch(url, {
        method: 'PUT',
        headers: getDefaultHeader(true),
        body:JSON.stringify(userDTO)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};


// WEBPACK FOOTER //
// ./src/components/User/userServices.js